import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FormVAQ_UB_4 from "../../Forms/FormVAQ_UB_4.js";
import Footer from "../../Includes/Layouts/VAQ_UB_4/Footer.js";
import FbViewPixel from "../../../Utility/FbViewPixel";
import "../../../assets/VAQ_UB_4/scss/VAQ_UB_4.scss";
import AccordSection from "../../Includes/Layouts/VAQ_UB_4/AccordSection";

const VAQ_UB_4 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="VAQ_UB_4" />
      <FbViewPixel />
      <div className="VAQ_UB_4">
        <FormVAQ_UB_4 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default VAQ_UB_4;
